module.exports = __webpack_public_path__ + "img/transfer-documents.e38a23e3.svg";